import React, { useState, useEffect } from "react";

import CustomDropDown from "./CustomDropDown";

const HeightInput = ({
    initialHeight,
    setPatientHeight
}) => {
    const [feet, setFeet] = useState(null);
    const [inches, setInches] = useState(null);
    const [init, setInit] = useState(false);

    const feetOptions = [
        { label: "3 feet", value: 3 },
        { label: "4 feet", value: 4 },
        { label: "5 feet", value: 5 },
        { label: "6 feet", value: 6 },
        { label: "7 feet", value: 7 }
    ];

    const inchOptions = [
        { label: "0 inches", value: 0 },
        { label: "1 inch", value: 1 },
        { label: "2 inches", value: 2 },
        { label: "3 inches", value: 3 },
        { label: "4 inches", value: 4 },
        { label: "5 inches", value: 5 },
        { label: "6 inches", value: 6 },
        { label: "7 inches", value: 7 },
        { label: "8 inches", value: 8 },
        { label: "9 inches", value: 9 },
        { label: "10 inches", value: 10 },
        { label: "11 inches", value: 11 }
    ];

    // ---=== Utilities ===--- //

    const heightToImperial = (height) => {
        const rawFeet = Math.max(height * 3.2808, 3);
        const rawInches = Math.round((rawFeet - Math.floor(rawFeet)) * 12);
        const adjustedFeet = Math.floor(rawFeet) + (rawInches === 12 ? 1 : 0);
        const adjustedInches = rawInches === 12 ? 0 : rawInches;
        setInches(adjustedInches);
        setFeet(adjustedFeet);
    };

    const heightToMetric = () => {
        let heightInInches = (feet * 12) + Number(inches);
        let newHeight = heightInInches * 0.0254;
        setPatientHeight(newHeight);
    };

    // ---=== useEffects ===--- //

    useEffect(() => {
        if (initialHeight && !init) {
            setInit(true);
            heightToImperial(initialHeight);
        }
    }, [initialHeight]);

    useEffect(() => {
        if (feet !== null && inches !== null) {
            heightToMetric();
        }
    }, [feet, inches]);

    // ---=== Render ===--- //

    return (
        feet !== null && inches !== null && (
            <React.Fragment>
                <div className="w-full self-stretch justify-start items-end gap-8 inline-flex">
                    <div className="grow shrink  w-full basis-0 flex-col justify-start items-start gap-2 inline-flex">
                        <div className="self-stretch w-full h-[70px] flex-col justify-start items-start gap-1.5 flex">
                            <div className="text-gray-700 w-full text-sm font-medium  leading-tight">Height</div>
                            <CustomDropDown
                                buttonFont={"font-normal"}
                                buttonTextColor="text-gray-500"
                                defaultValue={feet}
                                options={feetOptions}
                                // Callbacks
                                onSelectionCallback={setFeet}
                            />
                        </div>
                    </div>
                    <div className="grow shrink w-full  basis-0 flex-col justify-start items-start gap-2 inline-flex">
                        <div className="self-stretch w-full h-[70px] flex-col justify-start items-start gap-1.5 flex">
                            <div className="text-white w-full text-sm font-medium  leading-tight">height</div>
                            <CustomDropDown
                                buttonFont={"font-normal"}
                                buttonTextColor="text-gray-500"
                                defaultValue={inches}
                                options={inchOptions}
                                // Callbacks
                                onSelectionCallback={setInches}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    );
};

export default HeightInput;
